import * as THREE from "three";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import { RoomEnvironment } from "three/addons/environments/RoomEnvironment.js";
const cfgEl = document.getElementById("mw-config");
let CFG = {};
try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const PARTS = [
{
id: "shelf", label: "Plateau",
title: "Le plateau",
text: "Une lame blanche de 18 mm, profonde de 180 mm. Assez large pour un casque, des miniatures, des livres ou une plante, sans encombrer le mur.",
specs: [["Largeur", "880 mm (hors tout)"], ["Profondeur", "180 mm"], ["Épaisseur", "18 mm"], ["Finition", "Blanc mat"]],
anchor: [-0.9, 0.12, 1.25],
cam: [2.6, 4.4, 6.6], target: [0, -0.1, 0.9]
},
{
id: "fins", label: "Dérives GT3RS",
title: "Dérives GT3RS",
text: "Deux dérives ovales en 10 mm, vissées aux extrémités du plateau et marquées GT3RS en rouge. C'est la signature de l'aileron de course.",
specs: [["Épaisseur", "10 mm"], ["Marquage", "GT3RS rouge"], ["Fixation", "Vissée au plateau"]],
anchor: [4.42, -0.05, 1.7],
cam: [10.2, 1.1, 4.6], target: [4.1, -0.15, 1.4]
},
{
id: "brackets", label: "Supports ajourés",
title: "Supports ajourés",
text: "Deux supports en 18 mm, découpés en treillis comme une pièce de châssis. Ils portent le plateau par en dessous et allègent visuellement l'ensemble.",
specs: [["Épaisseur", "18 mm"], ["Nombre", "2"], ["Design", "Treillis ajouré"]],
anchor: [1.75, -0.95, 0.95],
cam: [6.2, -1.2, 5.6], target: [1.6, -0.75, 0.8]
},
{
id: "mounts", label: "Fixation murale",
title: "Fixation murale incluse",
text: "Chaque support se termine par un pied mural vissé. Vis et chevilles sont fournies : tout le nécessaire est dans la boîte.",
specs: [["Points de fixation", "2 pieds muraux"], ["Visserie", "Fournie"], ["Pose", "Facile"]],
anchor: [-1.75, -1.3, 0.45],
cam: [-3.6, -1.7, 5.4], target: [-1.6, -1.15, 0.35]
}
];
if (Array.isArray(CFG.parts)) CFG.parts.forEach((p, i) => { if (PARTS[i]) Object.assign(PARTS[i], p); });
const HOME_BASE = { cam: [8.2, 3.4, 12.8], target: [0, -0.6, 0.9] };
const HOME = { cam: [...HOME_BASE.cam], target: [...HOME_BASE.target] };
function decalTexture(text) {
const c = document.createElement("canvas"); c.width = 1024; c.height = 512;
const g = c.getContext("2d");
g.clearRect(0, 0, 1024, 512);
g.save();
g.translate(512, 256);
g.transform(1, 0, -0.22, 1, 0, 0);
g.font = "800 250px 'Saira Extra Condensed', 'Arial Narrow', Impact, sans-serif";
g.textAlign = "center"; g.textBaseline = "middle";
g.fillStyle = "#d8262c";
g.fillText(text, 0, 6);
g.restore();
const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 8;
return t;
}
function buildModel() {
const root = new THREE.Group();
const parts = {};
const mk = (id) => { const g = new THREE.Group(); g.userData.part = id; parts[id] = g; root.add(g); return g; };
const whiteMat = new THREE.MeshPhysicalMaterial({ color: 0xf1f0ec, roughness: .55, clearcoat: .25, clearcoatRoughness: .5 });
const blackMat = new THREE.MeshPhysicalMaterial({ color: 0x121315, roughness: .62, metalness: .05, clearcoat: .15, clearcoatRoughness: .6 });
const steelMat = new THREE.MeshStandardMaterial({ color: 0x9a9ea4, roughness: .3, metalness: .9 });
const side = (shape, depth, bevel = .012) => {
const g = new THREE.ExtrudeGeometry(shape, { depth, bevelEnabled: true, bevelThickness: bevel, bevelSize: bevel, bevelSegments: 2, curveSegments: 40 });
g.rotateY(-Math.PI / 2);
g.translate(depth / 2, 0, 0);
return g;
};
const shelfG = mk("shelf");
const board = new THREE.Shape();
board.moveTo(0.02, -0.18); board.lineTo(1.78, -0.18);
board.quadraticCurveTo(1.8, -0.18, 1.8, -0.16); board.lineTo(1.8, -0.02);
board.quadraticCurveTo(1.8, 0, 1.78, 0); board.lineTo(0.02, 0); board.lineTo(0.02, -0.18);
shelfG.add(new THREE.Mesh(side(board, 8.6, .008), whiteMat.clone()));
const fin = new THREE.Shape();
const N = 64, L = 1.4, H = .64, cz = 1.42, cy = -0.25;
for (let i = 0; i <= N; i++) {
const a = (i / N) * Math.PI * 2, ca = Math.cos(a), sa = Math.sin(a);
const px = Math.sign(ca) * Math.pow(Math.abs(ca), .62);
const py = Math.sign(sa) * Math.pow(Math.abs(sa), .8);
const taper = 1 - 0.18 * Math.max(0, ca);
const z = cz + px * L, y = cy + py * H * taper;
i === 0 ? fin.moveTo(z, y) : fin.lineTo(z, y);
}
const finGeo = side(fin, .1, .01);
const finG = mk("fins");
const decal = decalTexture(CFG.decal || "GT3RS");
[-1, 1].forEach((s) => {
const g = new THREE.Group();
g.position.x = s * 4.35;
const m = new THREE.Mesh(finGeo, blackMat.clone());
g.add(m);
const d = new THREE.Mesh(new THREE.PlaneGeometry(2.3, 1.15), new THREE.MeshStandardMaterial({ map: decal, transparent: true, roughness: .45, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -2 }));
d.position.set(s * .062, cy - .02, cz + .05);
d.rotation.y = s * Math.PI / 2;
g.add(d);
[0.55, 1.45].forEach((z) => {
const sc = new THREE.Mesh(new THREE.CylinderGeometry(.035, .035, .02, 16), steelMat.clone());
sc.rotation.z = Math.PI / 2;
sc.position.set(s * .062, -0.09, z);
g.add(sc);
});
g.rotation.x = 0.07;
finG.add(g);
});
const br = new THREE.Shape();
br.moveTo(0.12, -0.18);
br.lineTo(1.5, -0.18);
br.quadraticCurveTo(1.56, -0.18, 1.53, -0.25);
br.lineTo(0.62, -1.18);
br.lineTo(0.62, -1.62);
br.lineTo(0.04, -1.62);
br.lineTo(0.04, -1.08);
br.bezierCurveTo(0.3, -0.85, 0.5, -0.55, 0.62, -0.42);
br.lineTo(0.12, -0.42);
br.lineTo(0.12, -0.18);
const hole = (pts) => { const p = new THREE.Path(); p.moveTo(...pts[0]); pts.slice(1).forEach((q) => p.lineTo(...q)); p.closePath(); return p; };
const circ = (z, y, r) => { const p = new THREE.Path(); p.absarc(z, y, r, 0, Math.PI * 2, true); return p; };
br.holes.push(
hole([[0.8, -0.27], [1.32, -0.27], [1.06, -0.48]]),
circ(0.78, -0.5, .07),
hole([[0.66, -0.62], [0.9, -0.62], [0.72, -0.86]]),
circ(0.62, -1.0, .065)
);
const brGeo = side(br, .18, .01);
const brG = mk("brackets");
const footG = mk("mounts");
[-1.75, 1.75].forEach((x) => {
const m = new THREE.Mesh(brGeo, blackMat.clone());
m.position.x = x;
brG.add(m);
const foot = new THREE.Mesh(new THREE.BoxGeometry(.5, .62, .28), blackMat.clone());
foot.position.set(x, -1.33, 0.14);
footG.add(foot);
[-1.18, -1.48].forEach((y) => [-1, 1].forEach((s) => {
const sc = new THREE.Mesh(new THREE.CylinderGeometry(.03, .03, .02, 14), steelMat.clone());
sc.rotation.z = Math.PI / 2;
sc.position.set(x + s * .255, y, 0.14);
footG.add(sc);
}));
});
root.traverse((o) => { if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; } });
return { root, parts };
}
function initViewer(stage) {
let renderer;
try {
renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
} catch (e) {
const fb = stage.querySelector(".mw-stage-fallback"); if (fb) fb.textContent = "Aperçu 3D indisponible sur cet appareil";
return;
}
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputColorSpace = THREE.SRGBColorSpace;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.05;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
stage.prepend(renderer.domElement);
const scene = new THREE.Scene();
const pmrem = new THREE.PMREMGenerator(renderer);
scene.environment = pmrem.fromScene(new RoomEnvironment(), .04).texture;
const camera = new THREE.PerspectiveCamera(32, 1, .1, 200);
camera.position.set(...HOME.cam);
scene.add(new THREE.HemisphereLight(0xffffff, 0x1a1410, .35));
const key = new THREE.DirectionalLight(0xffffff, 2.4);
key.position.set(2.5, 5, 12); key.castShadow = true;
key.shadow.mapSize.set(2048, 2048);
Object.assign(key.shadow.camera, { left: -9, right: 9, top: 7, bottom: -7, near: 1, far: 30 });
key.shadow.bias = -0.0004; key.shadow.radius = 6;
scene.add(key);
const rim = new THREE.DirectionalLight(0xffd9d9, 0.9); rim.position.set(-7, 2, -1); scene.add(rim);
const wall = new THREE.Mesh(new THREE.PlaneGeometry(60, 30), new THREE.ShadowMaterial({ opacity: .28 }));
wall.position.z = -0.005; wall.receiveShadow = true; scene.add(wall);
const { root, parts } = buildModel();
scene.add(root);
root.position.y = .45;
const controls = new OrbitControls(camera, renderer.domElement);
controls.target.set(...HOME.target);
controls.enableDamping = true; controls.dampingFactor = .07;
controls.enablePan = false;
controls.enableZoom = false;
renderer.domElement.style.touchAction = "none";
controls.minDistance = 4; controls.maxDistance = 18;
controls.minPolarAngle = .15; controls.maxPolarAngle = 2.35;
controls.rotateSpeed = .9;
const hsWrap = stage.querySelector(".mw-hotspots");
const viewer = stage.closest(".mw-viewer") || stage;
const panel = viewer.querySelector(".mw-panel");
const chips = document.querySelectorAll("[data-mw-part]");
const hotspots = PARTS.map((p, i) => {
const b = document.createElement("button");
b.className = "mw-hs"; b.type = "button";
b.setAttribute("aria-label", "Voir le détail : " + p.label);
b.innerHTML = `<span>${p.label}</span>`;
b.addEventListener("click", (e) => { e.stopPropagation(); focus(i); });
hsWrap.appendChild(b);
return { el: b, v: new THREE.Vector3(...p.anchor) };
});
const intro = [
{ g: parts.mounts, from: new THREE.Vector3(0, 0, 2.5), d: 0 },
{ g: parts.brackets, from: new THREE.Vector3(0, -2.5, 2), d: .15 },
{ g: parts.shelf, from: new THREE.Vector3(0, 4, 0), d: .35 },
{ g: parts.fins, from: new THREE.Vector3(0, 0, 0), side: true, d: .6 }
];
const t0 = performance.now();
const INTRO = reduce ? 0 : 1.5;
const easeOut = (t) => 1 - Math.pow(1 - t, 4);
const easeIO = (t) => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
let tween = null, active = -1, idleAt = performance.now(), userTouched = false;
queueMicrotask(() => { size(); camera.position.set(...HOME.cam); });
function tweenTo(cam, tgt, dur = 1.15) {
tween = { fromC: camera.position.clone(), toC: new THREE.Vector3(...cam), fromT: controls.target.clone(), toT: new THREE.Vector3(...tgt), t: performance.now(), dur: reduce ? .01 : dur };
}
function setOpacity(activeId) {
Object.entries(parts).forEach(([id, g]) => {
const dim = activeId && id !== activeId;
g.traverse((o) => {
if (!o.isMesh) return;
const m = o.material;
m.userData.base ??= m.opacity;
m.userData.goal = dim ? .12 : m.userData.base;
m.transparent = true;
if (m.emissive) { if (m.userData.eGoal === undefined) m.emissiveIntensity = 0; m.userData.eGoal = (!dim && activeId) ? .07 : 0; }
});
});
}
function fill(i) {
const p = PARTS[i];
panel.querySelector("[data-mw-title]").textContent = p.title;
panel.querySelector("[data-mw-text]").textContent = p.text;
panel.querySelector("[data-mw-count]").textContent = `DÉTAIL ${i + 1} / ${PARTS.length}`;
const dl = panel.querySelector("[data-mw-specs]");
dl.innerHTML = "";
p.specs.forEach(([k, v]) => { const dt = document.createElement("dt"); dt.textContent = k; const dd = document.createElement("dd"); dd.textContent = v; dl.append(dt, dd); });
}
function focus(i) {
const p = PARTS[i];
const swapping = active !== -1;
active = i;
if (swapping && !reduce) { panel.classList.add("is-swapping"); setTimeout(() => { fill(i); panel.classList.remove("is-swapping"); }, 220); }
else fill(i);
viewer.classList.add("is-focused");
if (window.matchMedia("(max-width: 900px)").matches) setTimeout(() => panel.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "nearest" }), 80);
panel.setAttribute("aria-hidden", "false");
controls.autoRotate = false;
setOpacity(p.id);
tweenTo(p.cam, p.target);
hotspots.forEach((h, k) => h.el.classList.toggle("is-active", k === i));
chips.forEach((c) => c.classList.toggle("is-active", c.dataset.mwPart === p.id));
}
function reset() {
active = -1;
viewer.classList.remove("is-focused");
panel.setAttribute("aria-hidden", "true");
setOpacity(null);
tweenTo(HOME.cam, HOME.target);
hotspots.forEach((h) => h.el.classList.remove("is-active"));
chips.forEach((c) => c.classList.remove("is-active"));
idleAt = performance.now();
}
panel.querySelector("[data-mw-close]").addEventListener("click", reset);
panel.querySelector("[data-mw-prev]").addEventListener("click", () => focus((active - 1 + PARTS.length) % PARTS.length));
panel.querySelector("[data-mw-next]").addEventListener("click", () => focus((active + 1) % PARTS.length));
stage.addEventListener("keydown", (e) => { if (e.key === "Escape" && active !== -1) reset(); });
chips.forEach((c) => c.addEventListener("click", () => {
const i = PARTS.findIndex((p) => p.id === c.dataset.mwPart);
if (i < 0) return;
if (active === i) { reset(); return; }
const r = stage.getBoundingClientRect();
if (r.top < 0 || r.bottom > innerHeight) stage.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
focus(i);
}));
const ray = new THREE.Raycaster(), ndc = new THREE.Vector2();
let down = null;
renderer.domElement.addEventListener("pointerdown", (e) => { down = [e.clientX, e.clientY]; userTouched = true; });
renderer.domElement.addEventListener("pointerup", (e) => {
if (!down || Math.hypot(e.clientX - down[0], e.clientY - down[1]) > 6) return;
const r = renderer.domElement.getBoundingClientRect();
ndc.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
ray.setFromCamera(ndc, camera);
const hit = ray.intersectObject(root, true)[0];
if (!hit) { if (active !== -1) reset(); return; }
let o = hit.object; while (o && !o.userData.part) o = o.parent;
const i = PARTS.findIndex((p) => p.id === o?.userData.part);
if (i >= 0) focus(i);
});
renderer.domElement.addEventListener("pointermove", (e) => {
if (e.buttons) return;
const r = renderer.domElement.getBoundingClientRect();
ndc.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
ray.setFromCamera(ndc, camera);
renderer.domElement.style.cursor = ray.intersectObject(root, true).length ? "pointer" : "grab";
});
controls.addEventListener("start", () => { userTouched = true; controls.autoRotate = false; });
controls.addEventListener("end", () => { idleAt = performance.now(); });
function size() {
const w = stage.clientWidth, h = stage.clientHeight;
renderer.setSize(w, h, false);
camera.aspect = w / h;
camera.fov = 30;
camera.updateProjectionMatrix();
const hfov = 2 * Math.atan(Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)) * camera.aspect);
const need = 5.3 / Math.tan(hfov / 2);
const base = new THREE.Vector3(...HOME_BASE.cam).sub(new THREE.Vector3(...HOME_BASE.target));
const len = Math.max(base.length(), need);
const c = base.setLength(len).add(new THREE.Vector3(...HOME_BASE.target));
HOME.cam = [c.x, c.y, c.z];
controls.maxDistance = Math.max(18, len + 2);
if (active === -1 && !tween && performance.now() - t0 < 50) camera.position.copy(c);
}
new ResizeObserver(size).observe(stage);
let visible = true;
new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(stage);
const tmp = new THREE.Vector3();
let bob = 0;
function frame(now) {
requestAnimationFrame(frame);
if (!visible) return;
const el = (now - t0) / 1000;
intro.forEach((it) => {
const k = INTRO ? easeOut(THREE.MathUtils.clamp((el - it.d) / (INTRO * .7), 0, 1)) : 1;
if (it.side) {
it.g.children.forEach((c) => { const s = Math.sign(c.position.x); c.userData.x0 ??= c.position.x; c.position.x = c.userData.x0 + s * (1 - k) * 3; });
it.g.scale.setScalar(.6 + .4 * k);
it.g.scale.y = 1;
} else {
it.g.position.copy(it.from).multiplyScalar(1 - k);
}
});
if (active === -1 && !tween && !reduce && el > INTRO + .4) {
if (now - idleAt > 6000) { controls.autoRotate = true; controls.autoRotateSpeed = 1.1; }
bob += .01; root.position.y = .45 + Math.sin(bob) * .03;
}
if (tween) {
const k = Math.min(1, (now - tween.t) / (tween.dur * 1000)), e = easeIO(k);
camera.position.lerpVectors(tween.fromC, tween.toC, e);
controls.target.lerpVectors(tween.fromT, tween.toT, e);
if (k >= 1) tween = null;
}
controls.update();
root.traverse((o) => {
if (!o.isMesh) return;
const m = o.material;
if (m.userData.goal !== undefined) m.opacity += (m.userData.goal - m.opacity) * .12;
if (m.emissive && m.userData.eGoal !== undefined) {
m.emissive.setRGB(.85, .15, .17); m.emissiveIntensity += (m.userData.eGoal - m.emissiveIntensity) * .1;
}
});
const w = stage.clientWidth, h = stage.clientHeight;
root.updateMatrixWorld();
hotspots.forEach((hs, i) => {
tmp.copy(hs.v).applyMatrix4(root.matrixWorld).project(camera);
const x = (tmp.x * .5 + .5) * w, y = (-tmp.y * .5 + .5) * h;
hs.el.style.transform = `translate(${x}px,${y}px)`;
const off = tmp.z > 1 || x < 8 || x > w - 8 || y < 8 || y > h - 8 || el < INTRO + .2 || camera.position.z < .4;
hs.el.classList.toggle("is-hidden", off || (active !== -1 && active !== i));
});
renderer.render(scene, camera);
}
requestAnimationFrame(frame);
stage.classList.add("is-ready");
const hint = stage.querySelector(".mw-hint");
if (hint) hint.textContent = "3D · Tournez à 360°";
const rb = document.createElement("button");
rb.type = "button"; rb.className = "mw-icon-btn"; rb.textContent = "↺";
rb.setAttribute("aria-label", "Revenir à la vue de départ");
rb.style.cssText = "position:absolute;right:12px;top:12px;z-index:2;background:rgba(12,13,15,.6)";
rb.addEventListener("click", (e) => { e.stopPropagation(); controls.autoRotate = false; if (active !== -1) reset(); else { tweenTo(HOME.cam, HOME.target); idleAt = performance.now(); } });
stage.appendChild(rb);
setTimeout(() => { if (!userTouched && active === -1) idleAt = 0; }, (INTRO + .6) * 1000);
}
function toast(msg) {
let t = document.querySelector(".mw-toast");
if (!t) { t = document.createElement("div"); t.className = "mw-toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
t.textContent = msg; t.classList.add("is-on");
clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove("is-on"), 3600);
}
async function order(qty, btn) {
const id = CFG.variantId;
if (!id) { toast("Aperçu : le bouton ouvre le paiement une fois la page installée sur Shopify."); return; }
const old = btn ? btn.innerHTML : "";
if (btn) { btn.disabled = true; btn.textContent = "Ajout…"; }
try {
const r = await fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
});
if (!r.ok) throw new Error((await r.json()).description || "Erreur");
location.href = (window.Shopify?.routes?.root || "/") + "checkout";
} catch (e) {
toast("Impossible d'ajouter au panier : " + e.message);
if (btn) { btn.disabled = false; btn.innerHTML = old; }
}
}
function initPage() {
const qtyIn = document.getElementById("mw-qty");
document.querySelectorAll("[data-mw-step]").forEach((b) => b.addEventListener("click", () => {
qtyIn.value = Math.max(1, Math.min(20, (parseInt(qtyIn.value, 10) || 1) + Number(b.dataset.mwStep)));
}));
document.querySelectorAll("[data-mw-order]").forEach((b) => b.addEventListener("click", (e) => {
e.preventDefault();
order(Math.max(1, parseInt(qtyIn?.value, 10) || 1), b);
}));
const items = [...document.querySelectorAll("[data-mw-reveal]")];
if (!reduce && "IntersectionObserver" in window) {
const io = new IntersectionObserver((ens) => ens.forEach((en) => {
if (!en.isIntersecting) return;
en.target.classList.add("mw-revealed"); en.target.classList.remove("mw-pending"); io.unobserve(en.target);
}), { rootMargin: "0px 0px -8% 0px" });
items.forEach((el, i) => {
if (el.getBoundingClientRect().top > innerHeight) {
el.classList.add("mw-pending");
el.style.transitionDelay = (el.dataset.mwReveal || 0) + "ms";
io.observe(el);
}
});
}
document.querySelectorAll(".mw-faq details").forEach((d) => {
const s = d.querySelector("summary"), body = d.querySelector(".mw-faq-body");
s.addEventListener("click", (e) => {
if (reduce) return;
e.preventDefault();
if (d.open) {
const a = body.animate([{ height: body.scrollHeight + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: 320, easing: "ease-out" });
a.onfinish = () => d.open = false;
} else {
d.open = true;
body.animate([{ height: "0px", opacity: 0 }, { height: body.scrollHeight + "px", opacity: 1 }], { duration: 380, easing: "cubic-bezier(.22,.8,.2,1)" });
}
});
});
const bar = document.querySelector(".mw-bar"), hero = document.querySelector(".mw-product"), buy = document.querySelector(".mw-buy-row");
if (bar && hero) {
let pastHero = false, atBuy = false;
const upd = () => bar.classList.toggle("is-on", pastHero && !atBuy);
new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting; upd(); }).observe(hero);
if (buy) new IntersectionObserver(([en]) => { atBuy = en.isIntersecting; upd(); }).observe(buy);
}
document.querySelectorAll('a[href^="#"]').forEach((a) => a.addEventListener("click", (e) => {
const t = document.querySelector(a.getAttribute("href"));
if (!t) return; e.preventDefault();
t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
}));
}
function initLightbox() {
const imgs = [...document.querySelectorAll("[data-mw-photo]")];
if (!imgs.length) return;
const srcs = [...new Set(imgs.map((el) => el.dataset.mwPhoto))];
const box = document.createElement("div");
box.className = "mw-lightbox"; box.hidden = true;
box.setAttribute("role", "dialog"); box.setAttribute("aria-label", "Photos du produit");
const pic = document.createElement("img"); pic.alt = "";
const mk = (cls, label, txt) => { const b = document.createElement("button"); b.type = "button"; b.className = "mw-icon-btn " + cls; b.setAttribute("aria-label", label); b.textContent = txt; return b; };
const close = mk("mw-lb-close", "Fermer", "✕"), prev = mk("mw-lb-prev", "Photo précédente", "←"), next = mk("mw-lb-next", "Photo suivante", "→");
const count = document.createElement("div"); count.className = "mw-lb-count";
box.append(pic, close, prev, next, count);
document.querySelector(".mw").appendChild(box);
let i = 0;
const show = (k) => { i = (k + srcs.length) % srcs.length; pic.src = srcs[i]; count.textContent = `${i + 1} / ${srcs.length}`; };
const open = (src) => { show(Math.max(0, srcs.indexOf(src))); box.hidden = false; requestAnimationFrame(() => box.classList.add("is-on")); document.documentElement.style.overflow = "hidden"; close.focus(); };
const shut = () => { box.classList.remove("is-on"); document.documentElement.style.overflow = ""; setTimeout(() => { box.hidden = true; }, reduce ? 0 : 300); };
imgs.forEach((el) => el.addEventListener("click", () => open(el.dataset.mwPhoto)));
close.addEventListener("click", shut);
prev.addEventListener("click", () => show(i - 1));
next.addEventListener("click", () => show(i + 1));
box.addEventListener("click", (e) => { if (e.target === box) shut(); });
document.addEventListener("keydown", (e) => {
if (box.hidden) return;
if (e.key === "Escape") shut(); else if (e.key === "ArrowLeft") show(i - 1); else if (e.key === "ArrowRight") show(i + 1);
});
let sx = null;
box.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; }, { passive: true });
box.addEventListener("touchend", (e) => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); sx = null; });
}
initPage();
initLightbox();
const stage = document.querySelector(".mw-stage");
if (stage) {
(document.fonts?.ready || Promise.resolve()).then(() => initViewer(stage));
}
